import { render, staticRenderFns } from "./elasticPagination.vue?vue&type=template&id=bb7cb902"
import script from "./elasticPagination.vue?vue&type=script&lang=js"
export * from "./elasticPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports